<script setup>
import AnimatedSkewedEllipsMask from './AnimatedSkewedEllipsMask.vue'
import SkewedOvalEnergeticFrequencies from '../../../../assets/animations/energetic_frequencies/skewed_oval_energetic_frequencies.json'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  inFrequencies: {
    type: Boolean,
    default: true,
  },
  loopFrequencies: {
    type: Boolean,
    default: false,
  },
  loopFrequenciesDelay: {
    type: Number,
    default: 10,
  },
})

const outerEnergeticFrequenciesElement = ref(null)

const ellipsTimeline = ref(null)

const emit = defineEmits(['timeline', 'disappearTimeline'])

onMounted(() => {
  const outerEnergeticFrequencies = useLottie(outerEnergeticFrequenciesElement.value, SkewedOvalEnergeticFrequencies, { renderer: 'svg' })
  const timeline = gsapTimeline({ name: 'AnimatedSkewedEllipsMaskWithEnergeticFrequencies' }).add(ellipsTimeline)

  if (props.inFrequencies) {
    timeline.to(outerEnergeticFrequencies.playhead, outerEnergeticFrequencies.animation, '<')
  }

  emit('timeline', timeline)

  let loopTimeline
  if (props.loopFrequencies) {
    loopTimeline = gsapTimeline({ name: 'AnimatedSkewedEllipsMaskWithEnergeticFrequencies - Loop' })
      .set(outerEnergeticFrequencies.playhead, { frame: 0 }, props.loopFrequenciesDelay)
      .to(outerEnergeticFrequencies.playhead, { ...outerEnergeticFrequencies.animation, repeat: -1, repeatDelay: props.loopFrequenciesDelay }, '<')
  }

  emit('disappearTimeline', () => {
    if (loopTimeline) {
      loopTimeline.kill()
    }
    return gsapTimeline({ name: 'AnimatedSkewedEllipsMaskWithEnergeticFrequencies - Disappear' }).add(timeline.reverse().timeScale(-2.5))
  })
})
</script>

<template>
  <div class="relative">
    <AnimatedSkewedEllipsMask class="absolute z-10 w-[224px] h-[224px] ml-[56px] mt-[43px]" @timeline="ellipsTimeline = $event">
      <slot />
    </AnimatedSkewedEllipsMask>
    <div ref="outerEnergeticFrequenciesElement" class="w-[336px] h-[310px]" />
  </div>
</template>
